import React from 'react'
import { Flex, Text } from '@sendoutcards/quantum-design-ui'
import { useSelector } from 'src/hooks'

type SectionHeaderProps = {
  eyebrow?: string
  title?: string
  bold?: string
  description?: string
  color?: string
  alignment?: 'left' | 'center'
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  eyebrow,
  title,
  bold,
  description,
  color = '#404040',
  alignment = 'center',
}) => {
  const isTablet = useSelector(state => state.window.width <= 1050)
  const isMobile = useSelector(state => state.window.width <= 626)

  return (
    <Flex
      width="100%"
      flexDirection="column"
      alignItems={alignment === 'center' ? 'center' : 'start'}
    >
      {eyebrow && (
        <Text
          type={isMobile ? 'caption' : 'body'}
          content={eyebrow}
          alignment={alignment}
          style={{ color, opacity: 0.9 }}
        />
      )}
      {(title || bold) && (
        <Flex
          flexWrap="wrap"
          justifyContent={alignment === 'center' ? 'center' : 'start'}
          alignItems="baseline"
          rowGap="x0_75"
        >
          {title && (
            <Text
              type="title"
              weight="regular"
              content={title}
              alignment={alignment}
              style={{
                color,
                fontSize: isMobile ? 28 : isTablet ? 36 : 40,
                whiteSpace: 'nowrap',
              }}
            />
          )}
          {bold && (
            <Text
              type="title"
              weight="extraBold"
              content={bold}
              alignment={alignment}
              style={{
                color,
                fontSize: isMobile ? 28 : isTablet ? 36 : 40,
                marginLeft: '10px',
              }}
            />
          )}
        </Flex>
      )}
      {description && (
        <Text
          type={isMobile ? 'caption' : 'largeBody'}
          content={description}
          alignment={alignment}
          style={{ color, opacity: 0.9, marginTop: 6 }}
        />
      )}
    </Flex>
  )
}
